module.exports = __webpack_public_path__ + "img/20190813160718227.85a5c6e7.png";